module.exports = __webpack_public_path__ + "img/windows10.faa4fb99.svg";